// extracted by mini-css-extract-plugin
export var buttonContainer = "_47-6";
export var centeredToolbar = "_47-4";
export var dashdraw = "_47-c";
export var emptyStateContainer = "_47-8";
export var emptyStateText = "_47-9";
export var flowEditor = "_47-0";
export var flowEditorContainer = "_47-7";
export var hovered = "_47-1";
export var leftPanel = "_47-3";
export var mainCanvasContainer = "_47-a";
export var minimap = "_47-b";
export var selectMode = "_47-2";
export var toolbarSeparator = "_47-5";